export const strings = {
  Api: {
    Cancelled: 'User cancelled the network request.',
    Token: {
      Expired: 'Security token has expired',
      Invalid: 'Token issue, redirecting to login page',
      Missing: 'Security token is missing.',
    },
    UnknownError: 'Unknown server error has occurred.',
  },
  Authentication: {
    TimeoutDialog: {
      'Message-1': 'You are being timed out due to inactivity.',
      'Message-2': 'Please choose to stay signed in or to log out.',
      'Message-3': 'Otherwise, you will be logged out automatically',
      Stay: 'Stay Logged In',
      Title: 'Session Timeout',
    },
  },
  Site: {
    Abbreviations: {
      Advanced: 'adv',
      Standard: 'std',
    },
    Actions: 'Actions',
    Active: 'Active',
    Add: 'Add',
    AddNew: 'Add New',
    AddNewFormat: 'Add New {0}',
    Address: 'Address',
    Advanced: 'Advanced',
    All: 'All',
    Amount: 'Amount',
    Analytics: 'Analytics',
    And: 'And',
    Apply: 'Apply',
    Approve: 'Approve',
    Apps: 'Apps',
    Archive: 'Archive',
    Archived: 'Archived',
    Assign: 'Assign',
    Attachment: 'Attachment',
    Attribute: 'Attribute',
    Audience: 'Audience',
    AudienceBuilder: 'Audience Builder',
    Available: 'Available',
    Avg: 'Avg',
    AvgDonation: 'Avg Donation',
    BackToDashboard: 'Back to Dashboard',
    BackToLogin: 'Back to Login',
    Basic: 'Basic',
    Beta: 'Beta (Preview)',
    Bluebook: 'Bluebook',
    Both: 'Both',
    Broker: 'Broker',
    Build: 'Build',
    Business: 'Business',
    By: 'By',
    Cage: 'Cage',
    Caging: 'Caging',
    Calendar: 'Calendar',
    Cancel: 'Cancel',
    Cap: 'Cap',
    Card: 'Card',
    Cash: 'Cash',
    Category: 'Category',
    Check: 'Check',
    CIS: 'CIS',
    Clear: 'Clear',
    Clearword: 'Clearword',
    Client: 'Client',
    ClientLists: 'Client Lists',
    ClientNumber: '# of Clients',
    Clm: 'CLM',
    Clone: 'Clone',
    Code: 'Code',
    Combine: 'Combine',
    Compare: 'Compare',
    Components: {
      Creatable: {
        MaxItems: 'Trying to add {0} items, {1} is the maximum # of items allowed, please use the upload functionality',
      },
      Upload: {
        Errors: {
          Failed: 'Failed to read uploaded file: ',
        },
        Validation: {
          Csv: 'CSV file type is required',
          File: 'File is required',
        },
      },
    },
    Composite: 'Composite',
    Confirm: 'Confirm',
    Congressional: 'Congressional',
    Copied: 'Copied',
    Copy: 'Copy',
    Cost: 'Cost',
    Count: 'Count',
    CountWidgetDescription: 'LifeTime Across All Clients',
    Cpd: 'CPD',
    Create: 'Create',
    Created: 'Created',
    CreatedDate: 'Created Date',
    Creator: 'Creator',
    Criteria: 'Criteria',
    Cumulative: 'Cumulative',
    Current: 'Current',
    Custom: 'Custom',
    Dashboard: 'Dashboard',
    Data: 'Data',
    Date: 'Date',
    Day: 'Day',
    Dedupe: 'Dedupe',
    Default: 'Default',
    Delete: 'Delete',
    Deny: 'Deny',
    Description: 'Description',
    Desired: 'Desired',
    Detail: 'Detail',
    District: 'District',
    Dollar: 'Dollar',
    Donation: 'Donation',
    Donor: 'Donor',
    Donors: 'Donors',
    Download: 'Download',
    Edit: 'Edit',
    Email: 'Email',
    End: 'End',
    Enter: 'Enter',
    Entered: 'Entered',
    Entry: 'Entry',
    Error: 'Error',
    ErrorOccurred: 'An error has occurred.',
    Estimated: 'Estimated',
    ESun: 'eSUN',
    Exclude: 'Exclude',
    Existing: 'Existing',
    Export: 'Export',
    External: 'External',
    Failed: 'Failed',
    Female: 'Female',
    File: 'File',
    Filter: 'Filter',
    Final: 'Final',
    Finalize: 'Finalize',
    Finalized: 'Finalized',
    Finalizing: 'Finalizing',
    First: 'First',
    Flag: 'Flag',
    Gender: 'Gender',
    Generate: 'Generate',
    Given: 'Given',
    Gross: 'Gross',
    Group: 'Group',
    Has: 'Has',
    Hide: 'Hide',
    High: 'High',
    House: 'House',
    HSP: 'HSP',
    Inactive: 'Inactive',
    Include: 'Include',
    Information: 'Information',
    Insights: 'Insights',
    Integrations: 'Integrations',
    Interval: 'Interval',
    IO: 'IO',
    Is: 'Is',
    ItemsPerPage: 'Items per page',
    Left: 'Left',
    Line: 'Line',
    List: 'List',
    Load: 'Load',
    Loading: 'Loading',
    Location: 'Location',
    LockScreen: 'Lock Screen',
    Log: 'Log',
    Logout: 'Logout',
    Low: 'Low',
    Mail: 'Mail',
    MailCode: 'MailCode',
    Mailer: 'Mailer',
    Male: 'Male',
    Manager: 'Manager',
    Master: 'Master',
    MasterFile: 'MasterFile',
    Max: 'Max',
    Menu: 'Menu',
    MergePurge: 'Merge Purge',
    Min: 'Min',
    Models: 'Models',
    Modified: 'Modified',
    Money: 'Money',
    Month: 'Month',
    More: 'More',
    MultipleGiving: 'Multiple Giving',
    My: 'My',
    Name: 'Name',
    Net: 'Net',
    New: 'New',
    Next: 'Next',
    Nlm: 'NLM',
    NLS: 'NLS',
    No: 'No',
    NonDonor: 'Non-Donor',
    NonDonors: 'Non-Donors',
    None: 'None',
    Not: 'Not',
    Note: 'Note',
    NotificationCenter: {
      AsRead: 'Mark All as read',
      Delete: 'Delete notification',
      Empty: 'No new notifications',
      MarkRead: 'Mark as read',
      Notification: 'Notification',
      Unread: 'Only show unread',
    },
    Nth: 'Nth',
    Of: 'Of',
    Ok: 'OK',
    Omit: 'Omit',
    Only: 'Only',
    OnPoint: 'OnPoint',
    OpenEnded: 'Open Ended',
    Or: 'Or',
    Order: 'Order',
    OrderNumber: 'Order Number',
    OrderType: 'Order Type',
    Original: 'Original',
    Other: 'Other',
    Overlay: 'Overlay',
    Overview: 'Overview',
    Owner: 'Owner',
    Package: 'Package',
    Page: 'Page',
    PageNotFound: 'Sorry, page not found',
    Pages: {
      Analytics: {
        Bluebook: 'Bluebook',
        Reports: {
          Calendar: {
            Day: {
              GlobalFilterPlaceHolder: 'Search all clients...',
            },
            Month: {
              AddDay: 'Add day "{0}" to total',
              AddWeek: 'Add "{0}" to total',
              RemoveDay: 'Remove day "{0}" from total',
              RemoveWeek: 'Remove "{0}" from total',
            },
            Year: {
              AddMonth: 'Add "{0}" to total',
              AddQuarter: 'Add "{0}" to total',
              RemoveMonth: 'Remove "{0}" from total',
              RemoveQuarter: 'Remove "{0}" from total',
            },
          },
          ShippingLog: {
            FailedMessage: 'Failed to send shipping log request.',
            SelectMessage: 'Select the date range of orders you would like to pull.',
            ShippingLog: 'Shipping Log',
            SuccessMessage:
              'Successfully sent shipping log request. You should receive an email with the report shortly',
          },
        },
      },
      AudienceBuilder: {
        CompositeData: 'Composite Data',
        Create: {
          Condition: 'Condition',
          Data: 'Data',
          DataSource: 'Data Source',
          EqualTo: 'Equal to',
          ExternalLists: {
            ApproveSecretKey: '{0} has approved your secret key request for "{1}":',
            DenySecretKey: '{0} has denied your secret key request for "{1}"',
            HasZeroQuantity: 'This external list does not have any usable quantity',
            RequestSecretKey: '{0} has requested the secret key for your external list named "{1}"',
            RequestSecretKeyError: 'Failed sending secret key request',
            RequestSecretKeySuccess: 'Secret key request has been sent',
            SecretKey: 'Enter secret key...',
          },
          GreaterThan: 'Greater than',
          GreaterThanOrEqual: 'Greater than or equal',
          HPC: 'HPC',
          InState: 'In-State',
          LessThan: 'Less than',
          LessThanOrEqual: 'Less than or equal',
          ListOwner: 'List Owner',
          Location: 'Location',
          MRC: 'MRC',
          NoCap: 'No Cap',
          Omit: 'Omit',
          OrConditionMessage: 'Your Or Conditions will be set back to default after the Switch!',
          OutOfState: 'Out-of-State',
          RevertTooltip: 'Revert shop to last saved data',
          Sequences: 'Sequences',
          Source: 'Source',
          Tags: 'Tags',
          ThirdParty: 'Third Party',
          ThirdPartyDataSwitch: 'Changing the third-party data source will remove all other shop criteria.',
          Validations: {
            OneCondition: 'At least 1 condition is required',
            Required: 'Must select at least 1 search parameter',
          },
          Warnings: {
            ClientList: 'Not selecting a list will automatically assume you want to use {0} {1}',
          },
        },
        Dashboard: {
          ArchivePrompt: 'Are you sure you want to archive ',
          AudienceDashboard: 'AudienceDashboard',
          AudienceInsights: 'Audience Insights',
          ConversionRate: 'Conversion Rate',
          DeletePrompt: 'Are you sure you want to delete ',

          Messages: {
            Clone: {
              AudienceName: 'Audience Name required',
              Error: 'Clone failed',
              OrderNumber: 'Order Number required',
              Success: 'Clone completed successfully',
            },
            Process: {
              Dedupe: 'Dedupe across shops',
              FileName: 'Enter the name of the exported file',
              GiftDate:
                // eslint-disable-next-line max-len
                'Changing the gift dates will put audience into the "Active" state. The audience will need to be re-finalized to calculate the new sum amounts.',
              HpcMrc: 'Include HPC/MRC',
              HpcMrcHint: 'Should the extra HPC/MRC columns be included in the export',
              List: 'Enter the name of the list',
              Mailer: 'Enter the name of the mailer',
              Nth: 'Must be between {0} and {1}',
              NthShipped: 'Already shipped, setting this will cause the audience to be refreshed',
              OrderNumber: 'Enter the order that will appear in the email',
              RedPointFileName: 'Filename is required to match PO when sending to RedPoint',
              Refresh: 'Re-runs and updates the snapshot with the current results as of {0}',
              SendTo: 'Who would you like the export to be send to',
              SendToRp: 'Send to RedPoint',
              SendToRpHint: 'List will be loaded via RedPoint into corresponding ADPS package',
              Subject: 'Enter a custom email subject',
              Validation: {
                Email: '1 or more email addresses are invalid',
                Nth: 'Package count must be greater than 0',
              },
            },
            Status: {
              Archived: {
                Error: 'Failed to archived audience',
                Success: 'Audience has been archived',
              },
              Export: {
                Error: 'Failed to send ship request',
                Success: 'Ship request successfully sent',
              },
              Finalized: {
                Error: 'Failed to send finalize request',
                Success: 'Finalize request successfully sent',
              },
              Unarchive: {
                Error: 'Failed to un-archived audience',
                Success: 'Audience has been unarchived',
              },
              Update: {
                Error: 'Failed to update audience',
                Success: 'Audience has been updated',
              },
            },
            Tooltips: {
              Run: 'Run currently unavailable when finalized',
            },
          },
          ReactivatePrompt: 'Are you sure you want to re-activate',
          SearchPlaceholder: 'Search segment name or client',
          Sort: 'Are you sure you want to sort',
          UnarchivePrompt: 'Are you sure you want to unarchive ',
        },
        DollarType: 'Dollar Type',
        Export: {
          Messages: {
            Error: 'Error occurred exporting ',
            Success: 'Export is processing, an email will be sent once the file has been generated.',
          },
        },
        ExternalList: {
          AcxiomMatches: 'Acxiom Matches',
          ExternalListManagement: 'External List Management',
          Form: {
            Client: 'Client',
            File: 'File',
            Name: 'Name',
            Tags: 'Tags',
            TagsPlaceHolder: 'Select Tags',
            Validation: {
              Client: 'Client field is required.',
              Csv: '.csv file type is required.',
              File: 'File field is required.',
              Name: 'Filename is required.',
            },
          },
          HSPDonorMatches: 'HSP Donor Matches',
          L2DonorMatches: 'L2 Matches',
          ListManagement: 'List Management',
          Messages: {
            Parquet: {
              Copied: 'Path copied to ClipBoard',
              Error: 'Error Copying Parquet Path. Path does not exist for External List',
              Label: 'File Path',
              NotReady: '(Processing) Not ready',
              Placeholder: 'Copy File Path',
            },
            SecretKey: {
              Copied: 'Secret key successfully copied to Clipboard',
              CopyKeyError: 'Error Copying Secret Key!! Key is Empty',
              GenerateKeyError: 'Error generating new key',
              Label: 'Secret Key',
              ListError: 'No External List associated with key',
              RefreshLabel: 'Refresh Secret Key',
              Success: 'Secret key successfully generated',
            },
            Status: {
              Delete: {
                Error: 'Failed deleting external list "{0}"',
                Success: 'External list "{0}" has been deleted',
              },
              Update: {
                Error: 'Failed updating list',
                Success: 'External list "{0}" has been updated',
              },
              Upload: {
                Error: 'Failed uploading list',
                Success: 'External list "{0}" has been uploaded',
              },
            },
          },
        },
        Frequency: 'Frequency',
        Monetary: 'Monetary',
        Nls: {
          NlsOrderManagement: 'NLS Order Management',
        },
        Recency: 'Recency',
        Results: {
          DonationSearchPlaceHolder: 'Search for a client, mailcode, or package',
          Draft: 'Draft',
          SearchPlaceHolder: 'Search for name, address, city or something',
          Templates: 'Templates',
        },
        Save: {
          GiftAmount: 'Gift Amount',
          Messages: {
            Error: 'Erroring saving audience',
            Success: 'Save was successful.',
          },
          SaveAsMaster: 'Save As Master',
          SaveAsPrebuilt: 'Save As Prebuilt',
          Validation: {
            Client: {
              Required: 'Client is required',
            },
            GiftAmount: {
              EndDate: 'End date must be after start date',
              StartDate: 'Start date must be before end date',
            },
            MailCode: {
              Required: 'Mail code is required',
            },
            Name: {
              DropDown: 'Must select an audience',
              Input: 'Audience name is required',
            },
            OrderType: {
              Required: 'Order type is required',
            },
          },
        },
        Sort: {
          Messages: {
            Error: 'Error occurred sorting MailCodes',
            NoMailCodes: 'No MailCodes found',
            Success: 'MailCodes successfully sorted',
          },
        },
      },
      Bluebook: {
        BackToBluebookDashboard: 'Back to Bluebook',
        CagingHistory: 'Caging History for ',
        Campaign: 'Campaign',
        ClientDashboard: 'Client Dashboard',
        CLM: 'CLM',
        Cost: 'Cost',
        CPD: 'CPD',
        DashBoard: 'Bluebook Dashboard',
        Gross: 'Gross',
        Incidental: 'Incidental Costs',
        IO: 'IO',
        LastUpdate: 'Last Update as of: ',
        ListRental: 'List Rental Income',
        Mailed: 'Mailed',
        NLM: 'NLM',
        Non: 'Non',
        Phase: 'Phase',
        Qty: 'Qty',
        ReportDate: 'Report Date: ',
        Rsp: 'Rsp',
        Utility: 'Utility',
        WhiteMailIncome: 'WhiteMail Income',
      },
      ChangePassword: {
        Confirm: 'Confirm new password',
        CurrentPassword: 'Current Password',
        NewPassword: 'New Password',
        NewPasswordMessage: 'To conform with our strong password policy, the following rules must be met:',
        PasswordStrength: 'Password Strength',
        Strength: {
          Bad: 'Bad',
          Fair: 'Fair',
          Good: 'Good',
          Strong: 'Strong',
          Weak: 'Weak',
        },
        Success: 'Password successfully changed',
        Title: 'Change Password',
      },
      Dashboard: {
        AnalyticsDashboard: 'Analytics Dashboard',
        DonorComposite: 'Donor Composite',
        LeastEngaged: 'Least Engaged',
        MailByState: 'Mail by State',
        MailInsights: 'Mail Insights',
        MailPerformance: 'Mail Performance',
        MostEngaged: 'Most Engaged',
        Top5ClientMailing: 'Top 5 Client Mailing',
        TotalPeople: 'Total people',
      },
      Integrations: {
        Acxiom: 'Acxiom',
        Airtable: 'Airtable',
        Intacct: 'Intacct',
        L2: 'L2',
      },
      ListPerformance: {
        ListPerformance: 'List Performance',
      },
      NlsOrders: {
        ExportFailed: 'Export Failed',
        Exporting: 'Exporting',
        Finalized: 'Finalized',
        FinalizeFailed: 'Finalize Failed',
        FinalizePending: 'Finalize Pending',
        NlsOrderManagement: 'NLS Orders',
        Notes: 'Add a note that will be appended to the end of the email',
        Number: '#',
        QuantityFailed: 'Quantity Failed',
        QuantityPending: 'Pending Quantity',
        QuantityUpdated: 'Quantity Updated',
        Resend: 'Re-Send',
        Shipped: 'Shipped',
        ShippedFailed: 'Shipped Failed',
        ShippedPending: 'Shipped Pending',
        Universe: 'Universe',
        WaitingForApproval: 'Waiting Approval',
      },
      Security: {
        Groups: 'Groups',
        Users: 'Users',
      },
      Utilities: {
        Caging: {
          title: 'Dailies Management',
          Validation: {
            delete: 'Daily Entry was successfully deleted',
            deleteConfirmation: 'Are you sure you would like to delete this entry',
            errorDelete: 'Error deleting  entry',
            errorSaving: 'Error saving new Daily entry',
            errorUpdating: 'Error updating Daily entry',
            fileType: '.csv file type is required.',
            requiredField: 'Field Required',
            save: 'Save Successful',
            title: 'Delete Caging Entry',
            update: 'Update Successful',
          },
        },
        Exceptions: {
          deleteModal: 'Are you sure you would like to delete the mailcode',
          Search: 'Search across all columns',
          title: 'Exception',

          Validations: {
            assignNewMailCode: {
              error: 'Error saving new mailcode',
              success: 'Save Successful',
            },
            deleteMailCode: {
              error: 'Error deleting mailcode',
              success: 'Delete Successful',
            },
          },
          whiteMailModal: 'Are you sure you would like to assign the mailcode to WhiteMail',
        },

        LRI: {
          LRI: 'LRI',
          LRIManagement: 'LRI Management',
          Validation: {
            delete: 'LRI Entry was successfully deleted',
            deleteConfirmation: 'Are you sure you would like to delete this entry',
            errorDelete: 'Error deleting LRI entry',
            errorSaving: 'Error saving new LRI entry',
            errorUpdating: 'Error updating LRI entry',
            fileType: '.csv file type is required.',
            requiredField: 'Field Required',
            save: 'Save Successful',
            update: 'Update Successful',
          },
        },
        PDF: {
          PDF: 'PDF',
          PDFManagement: 'PDF Management',
        },
        Whitemail: {
          Card: 'Card',
          CardDonors: 'Card Donors',
          Cash: 'Cash',
          CashDonors: 'Cash Donors',
          Check: 'Check',
          CheckDonors: 'Check Donors',
          Validation: {
            delete: 'WhiteMail Entry was successfully deleted',
            deleteConfirmation: 'Are you sure you would like to delete this entry',
            errorDelete: 'Error deleting WhiteMail entry',
            errorSaving: 'Error saving new WhiteMail entry',
            errorUpdating: 'Error updating WhiteMail entry',
            fileType: '.csv file type is required.',
            requiredField: 'Field Required',
            save: 'Save Successful',
            title: 'Delete WhiteMail Entry',
            update: 'Update Successful',
          },
          Whitemail: 'Whitemail',
          WhitemailManagement: 'Whitemail Management',
        },
      },
      Workflow: {
        CIS: 'CIS',
        MergePurge: 'Merge Purge',
        Whitemail: 'Whitemail',
      },
    },
    Party: 'Party',
    Past: 'Past',
    Pending: 'Pending',
    Phase: 'Phase',
    PO: 'PO',
    PodClient: 'Pod Client',
    Prebuilt: 'Prebuilt',
    Preview: 'Preview',
    Previous: 'Previous',
    Primary: 'Primary',
    Processing: 'Processing',
    Profile: 'Profile',
    Projected: 'Projected',
    Pull: 'Pull',
    Qty: 'Qty',
    Quantity: 'Quantity',
    Quarter: 'Quarter',
    Range: 'Range',
    Reactivate: 'Re-Activate',
    Ready: 'Ready',
    Received: 'Received',
    Recency: 'Recency',
    Refresh: 'Refresh',
    Reject: 'Reject',
    Remove: 'Remove',
    Repeat: 'Repeat',
    Report: 'Report',
    Request: 'Request',
    Requested: 'Requested',
    ReSequence: 'Re-Sequence',
    Reset: 'Reset',
    Retry: 'Retry',
    ReturnTo: 'Return to {0}',
    Revert: 'Revert',
    RFM: 'RFM',
    Right: 'Right',
    Rsp: 'Rsp',
    Run: 'Run',
    Save: 'Save',
    SaveAndRun: 'Save & Run',
    SCF: 'SCF',
    Search: 'Search',
    SearchColumns: 'Search name, client or owner...',
    Second: 'Second',
    Secondary: 'Secondary',
    Security: 'Security',
    Segment: 'Segment',
    Select: 'Select',
    Selected: 'Selected',
    Send: 'Send',
    SequenceNumber: 'Sequence Number',
    ServerError: 'An error has occurred communicating with the server.',
    Set: 'Set',
    Settings: 'Settings',
    Ship: 'Ship',
    Shipped: 'Shipped',
    Shop: 'Shop',
    Show: 'Show',
    SingleGiving: 'Single Giving',
    Sort: 'Sort',
    Source: 'Source',
    Specific: 'Specific',
    Specified: 'Specified',
    Standard: 'Standard',
    Start: 'Start',
    State: 'State',
    Status: 'Status',
    Studio: 'Studio',
    Subject: 'Subject',
    Submit: 'Submit',
    Summary: 'Summary',
    // eslint-disable-next-line id-length
    T: 'T',
    Tag: 'Tag',
    Template: 'Template',
    Third: 'Third',
    Title: 'Title',
    To: 'To',
    Total: 'Total',
    Type: 'Type',
    Unarchive: 'Unarchive',
    Unknown: 'Unknown',
    Update: 'Update',
    UpdateAndRun: 'Update & Run',
    Upload: 'Upload',
    UploadDate: 'Upload Date',
    User: 'User',
    UserNumber: '# of Users',
    UserProfile: 'User Profile',
    Utilities: 'Utilities',
    Validation: {
      GreaterThanZero: '{0} must be greater than 0',
      InvalidNumber: 'Invalid Number',
      IsRequired: '{0} is required',
      LessThan: '{0} must be less than {1}',
      MoreThan: '{0} must be more than {1}',
    },
    Value: 'Value',
    View: 'View',
    ViewAll: 'View All',
    ViewAllAudiences: 'View All Audiences',
    ViewBlueBook: 'View Bluebook',
    Viewer: 'Viewer',
    ViewMore: 'View More',
    Warning: 'Warning',
    Week: 'Week',
    Workflow: 'Workflow',
    Year: 'Year',
    Yes: 'Yes',
    Zip: 'Zip',
  },
} as const;
